import Lang from '/@/modules/core/app/services/Lang';
import Enum from '/@/modules/core/app/helpers/Enum';

export class FuneralPreArrangementCeremonyType extends Enum {
  static TRADITIONAL_CEREMONY = {
    key: 'traditional_ceremony',
    get value() {
      return Lang.t('asset.traditional-ceremony');
    },
    get description() {
      return Lang.t('asset.religious-church-of');
    }
  };

  static LIFE_CELEBRATION = {
    key: 'life_celebration',
    get value() {
      return Lang.t('asset.life-celebration');
    },
    get description() {
      return Lang.t('asset.non-ceremony-celebrate');
    }
  };
}
